export const devices = [
  {
    id: 1,
    name: "J16",
    protocol: "gt06",
    port: "5023",
    category: "Rastreador Veicular",
    features: ["GPS/GLONASS", "GSM", "Bloqueio de motor", "Alertas"],
    pdfManual: require('../pdfs/Instrucoes_Comandos_J16.pdf'),
    documentation: `
# J16 - Rastreador GPS Veicular

## Características Principais
- GPS/GLONASS dual mode
- Rede GSM Quad-band
- Bloqueio remoto de motor
- Alertas de velocidade e geo-cerca
- Bateria de backup integrada

## Configuração
1. Insira o chip SIM no dispositivo
2. Configure o servidor: SERVER#IP#PORTA#
3. Exemplo: SERVER#seu-servidor.com#5023#
4. Aguarde confirmação por SMS

## Instalação
- Conecte o fio vermelho ao positivo 12V
- Conecte o fio preto ao negativo (GND)
- Conecte o fio amarelo ao relé de ignição

## Comandos Principais
- Verificar status: STATUS#
- Rastrear posição: POSITION#
- Configurar APN: APN#nome_apn#usuario#senha#
    `
  },
  {
    id: 2,
    name: "TK103-2B",
    protocol: "gps103",
    port: "5001",
    category: "Rastreador Veicular",
    features: ["GPS", "GSM", "Geo-cerca", "Alertas de velocidade"],
    documentation: `
# TK103-2B - Rastreador GPS

## Características
- Rastreamento em tempo real via GPS
- Alertas por SMS
- Geo-cerca configurável
- Histórico de rotas

## Configuração Básica
1. Configure o número admin: admin123456 seu_numero
2. Configure APN: apn123456 nome_apn
3. Configure servidor: adminip123456 IP PORTA

## Comandos SMS
- Localização: G123456#
- Ouvir ambiente: monitor123456
- Parar motor: stop123456
    `
  },
  {
    id: 3,
    name: "GL200",
    protocol: "gl200",
    port: "5004",
    category: "Rastreador Avançado",
    features: ["GPS/GLONASS", "Bluetooth", "Acelerômetro", "Alta precisão"],
    documentation: `
# GL200 - Rastreador GPS Profissional

## Características Avançadas
- GPS/GLONASS com alta precisão
- Bluetooth 4.0 integrado
- Acelerômetro 3 eixos
- Bateria de backup
- Memória interna para dados offline

## Instalação
1. Conecte à fonte de alimentação 9-36V DC
2. Insira chip SIM ativo
3. Configure via SMS ou interface USB

## Configuração de Servidor
Comando: AT+GTBSI=<password>,<hostname>,<port>,,,,<FFFF>$

Exemplo: AT+GTBSI=gl200w,seu-servidor.com,5004,,,,0000$
    `
  },
  {
    id: 4,
    name: "GT06N",
    protocol: "gt06",
    port: "5023",
    category: "Rastreador Compacto",
    features: ["GPS", "GSM", "Compacto", "Fácil instalação"],
    documentation: `
# GT06N - Rastreador GPS Compacto

## Características
- Design compacto e discreto
- GPS integrado
- GSM Quad-band
- Bateria interna
- À prova d'água (IP65)

## Configuração
1. Ligue o dispositivo
2. Configure via SMS: SERVER,1,seu-servidor.com,5023#
3. Verifique conexão: STATUS#

## Instalação
Dispositivo com bateria interna, ideal para:
- Veículos
- Motos
- Equipamentos portáteis
    `
  },
  {
    id: 5,
    name: "Teltonika FMB920",
    protocol: "teltonika",
    port: "5027",
    category: "Rastreador Industrial",
    features: ["GPS/GLONASS", "Bluetooth", "I/O Digital", "CAN bus"],
    documentation: `
# Teltonika FMB920 - Rastreador GPS Profissional

## Características Premium
- GPS/GLONASS/Galileo
- Bluetooth LE para sensores
- 2 entradas digitais / 2 saídas digitais
- Leitura CAN bus (OBD-II)
- Acelerômetro e giroscópio

## Configuração via Configurador
1. Baixe o Teltonika Configurator
2. Conecte via USB ou Bluetooth
3. Configure parâmetros de servidor
4. Host: seu-servidor.com
5. Porta: 5027
6. Protocol: TCP

## Recursos Avançados
- Detecção de acidentes
- Monitoramento de combustível
- Leitura de dados do motor via CAN
- Alertas configuráveis
    `
  },
  {
    id: 6,
    name: "ST901",
    protocol: "suntech",
    port: "5011",
    category: "Rastreador Veicular",
    features: ["GPS", "GSM", "Entradas/Saídas", "Robusto"],
    documentation: `
# ST901 - Suntech Rastreador GPS

## Características
- Design robusto para uso industrial
- Múltiplas entradas e saídas
- Suporte a sensores externos
- Bateria de backup

## Configuração
Use o software ST Configuration Tool:
1. Conecte via cabo USB
2. Configure IP/Porta do servidor
3. IP: seu-servidor.com
4. Porta: 5011

## Aplicações
- Frotas comerciais
- Veículos pesados
- Maquinário
- Logística
    `
  },
  {
    id: 7,
    name: "Concox GT06E",
    protocol: "gt06",
    port: "5023",
    category: "Rastreador Popular",
    features: ["GPS", "Bloqueio motor", "Geo-cerca", "Alertas"],
    documentation: `
# Concox GT06E - Rastreador GPS

## Recursos
- Rastreamento em tempo real
- Bloqueio remoto de combustível
- Alertas de geo-cerca
- Botão SOS
- Escuta ambiental

## Setup Rápido
1. SMS: APN,nome_apn,usuario,senha#
2. SMS: SERVER,1,seu-servidor.com,5023#
3. SMS: HBT,30# (heartbeat a cada 30s)

## Comandos Úteis
- Posição: G#
- Status: STATUS#
- Reiniciar: RESET#
    `
  },
  {
    id: 8,
    name: "Queclink GV500",
    protocol: "gl200",
    port: "5004",
    category: "Rastreador Premium",
    features: ["GPS/GLONASS", "3G/4G", "WiFi", "Câmera compatível"],
    documentation: `
# Queclink GV500 - Rastreador GPS 4G

## Características Premium
- Conectividade 4G LTE
- GPS/GLONASS dual mode
- WiFi positioning
- Suporte para câmera IP
- Múltiplas I/O configuráveis

## Configuração Avançada
Via AT commands:
AT+GTBSI=gv500,seu-servidor.com,5004,,,,FFFF$

## Recursos Especiais
- Vídeo ao vivo (com câmera)
- Detecção de jamming
- Monitoramento de motorista
- Relatórios detalhados
    `
  }
];

export const protocols = [
  { name: "gt06", port: "5023", description: "Protocolo GT06 - Dispositivos Concox e compatíveis" },
  { name: "gps103", port: "5001", description: "Protocolo GPS103 - Coban e similares" },
  { name: "gl200", port: "5004", description: "Protocolo GL200 - Queclink devices" },
  { name: "teltonika", port: "5027", description: "Protocolo Teltonika - Dispositivos profissionais" },
  { name: "suntech", port: "5011", description: "Protocolo Suntech - Rastreadores industriais" },
  { name: "t55", port: "5005", description: "Protocolo T55 - Dispositivos genéricos" },
  { name: "osmand", port: "5055", description: "OsmAnd - Aplicativos móveis" }
];

